// Basic config here.
var config = {
	apiURL: "/api",
}

export default config;